import Loadable from '@townsquare/loadable';
import { agentStudioRoute } from '@townsquare/routes/agent-studio';

const AgentStudioLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "agent-studio" */ './components/AgentStudioView'),
  loading: () => null,
});

agentStudioRoute.component = AgentStudioLoadable;
export const agentStudioRouterRoute = agentStudioRoute;
